module.exports = __webpack_public_path__ + "img/big3-17.0cb6e93d.jpg";